import CheckMarkIcon from "@/assets/icons/checkMark.svg";
import { TrainingAdvantageItemProps } from "./types";
import styles from './trainingAdvantageItem.module.scss'

export const TrainingAdvantageItem = ({ advantage }: TrainingAdvantageItemProps) => {
  return (
    <li className={styles.trainingAdvantageItem}>
      <img src={CheckMarkIcon} alt="icon" />
      <p>{advantage}</p>
    </li>
  );
};